import React, { useEffect, useState } from 'react';
import { Amplify } from 'aws-amplify';

import { EventType } from '@azure/msal-browser';
import { msalInstance } from 'utils/azureB2C';

import './main.css';
import App from './App';
import { initLocale, getCurrentLocale } from 'utils/intl';
import { MaterialUIControllerProvider } from './context';
import { createRoot } from 'react-dom/client';
import logger from 'utils/logger';

const log = logger.createLogger('main');

const cognitoConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_AWS_COGNITO_USER_POOL_ID || '',
      userPoolClientId: import.meta.env.VITE_AWS_COGNITO_APP_CLIENT_ID || '',
      region: import.meta.env.VITE_AWS_COGNITO_REGION || '',
      // Optional settings
      loginWith: {
        email: true,
        phone: false,
        username: true,
      },
    },
  },
};

// Configure Amplify with validated config
Amplify.configure(cognitoConfig);

// Default to using the first account if no account is active on page load
if (
  !msalInstance.getActiveAccount() &&
  msalInstance.getAllAccounts().length > 0
) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

msalInstance.addEventCallback((event) => {
  if (
    (event.eventType === EventType.LOGIN_SUCCESS ||
      event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
      event.eventType === EventType.SSO_SILENT_SUCCESS) &&
    event.payload.account
  ) {
    msalInstance.setActiveAccount(event.payload.account);
  }
});

/**
 *  Init intl to the default language Japanese.
 *  And then render the app.
 * @returns
 */
const AppWrapper = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check the language from the browser if not in the local storage
    const locale = getCurrentLocale();
    const initialize = async () => {
      await initLocale(locale);
      setLoading(false);
    };
    initialize();
  }, []);

  if (loading) {
    return <></>;
  }

  return (
    <MaterialUIControllerProvider>
      <App />
    </MaterialUIControllerProvider>
  );
};

// Create a root
const root = createRoot(document.getElementById('root'));

// Render the app
root.render(
  <React.StrictMode>
    <AppWrapper />
  </React.StrictMode>
);
